export default function getDomainName(emailAddress: string | undefined): string | undefined {
    const index = emailAddress?.indexOf("@") ?? -1;
    if (emailAddress && index >= 0) {
        return emailAddress.substring(index + 1);
    }
    return undefined;
}
